import { COLORS } from '@/constants';

type WalletCheckIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const WalletCheckIcon = ({
  width = 24,
  height = 24,
  ...rest
}: WalletCheckIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6 38L10 42L22 30"
      stroke={COLORS['secondary/500']}
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 6H10C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14H36V10C36 7.79086 34.2092 6 32 6Z"
      stroke={COLORS['secondary/500']}
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 42H38C40.2092 42 42 40.2092 42 38V18C42 15.7909 40.2092 14 38 14H14M6 28V10"
      stroke={COLORS['secondary/500']}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42 24H36C34.8954 24 34 24.8954 34 26V30C34 31.1046 34.8954 32 36 32H42"
      stroke={COLORS['secondary/500']}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

